// eslint-disable-next-line @eslint-community/eslint-comments/disable-enable-pair
/* eslint-disable camelcase */

'use client';

import classnames from 'classnames/bind';
import { memo, useEffect, useRef } from 'react';
import {
  EAnalytics,
  ENumberOfCalls,
  WATCH_OF_INTERSECTING_DELAY,
} from '@/_constants/analytics';
import { watchOfIntersecting } from '@/_utils/watch-of-intersecting';
import { useAnalytics } from '@/_hooks/use-analytics';
import { EBlockName } from '@/_components/promo-zone/_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'CardObserver';

type TProps = {
  blockName: EBlockName;
};

export const CardObserver = memo(function CardObserverComponent({
  blockName,
}: TProps) {
  const intersectionTargetRef = useRef<HTMLDivElement | null>(null);
  const sendEvent = useAnalytics();

  useEffect(() => {
    const sendAnalytics = ({ duration }: { duration: number }): void => {
      const config = {
        name: EAnalytics.SUPPLIER_LANDING_PROMO_V,

        params: {
          duration,
          name_block: blockName,
          // eslint-disable-next-line @portals/custom-plugin/todo-checker
          // TODO: add later
          // name_subblock: currentSlideTitle,
        },
      };

      sendEvent(config);
    };

    watchOfIntersecting({
      element: intersectionTargetRef.current,
      callback: sendAnalytics,
      delay: WATCH_OF_INTERSECTING_DELAY,
      numberOfCalls: ENumberOfCalls.REGULARLY,
    });
  }, [blockName, sendEvent]);

  return <div ref={intersectionTargetRef} className={cn(BLOCK_NAME)} />;
});
